import { Container, Box, Button, Grid, Typography, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import UserManagementListItem from '../shared/atom/UserManagementListItem'
import MainHeader from '../shared/organism/MainHeader'
import { CorporateActions, InvitedAndActiveEmployeesSelector, ModalOpenSelector, SelectCorporateCode, SelectAccountType, fetchUsers, fetchCode, ExecutiveEmployeesSelector} from '../../redux/corporateService'
import AddEmplyeesModal from '../shared/organism/AddEmployeesModal'
import { useAppDispatch, useAppSelector } from '../../redux/storeExports'
import ExecutiveUserManagementListItem from '../shared/atom/ExecutiveUserManagementListItem'
import CircularProgress from '@mui/material/CircularProgress';
import {store} from '../../redux/store'
import { FetchExecutiveUsers } from '@meprism/shared/src/redux/profile/ProfileSlice'
const UserManagementView = () => {
  const accountType = SelectAccountType()
  const isExecutiveAdmin = accountType === 'executive'
  const executiveEmployees = useAppSelector(ExecutiveEmployeesSelector) 
  const [isLoading, setIsLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("")
  const dispatch=useAppDispatch()
  const open = ModalOpenSelector()
  const corporateCode = SelectCorporateCode()
  const handleOpen = () => dispatch(CorporateActions.setModalOpen(true))
  const filteredEmployees = InvitedAndActiveEmployeesSelector()

  useEffect(()=>{
      const fetchEmployeeUsers = async()=>{
      try{
        setIsLoading(true)
        if(isExecutiveAdmin){
        const code = await dispatch(fetchCode()).unwrap()
        await dispatch(FetchExecutiveUsers(code))}
      else{
        await store.dispatch(fetchUsers())
      }}catch(e){
        console.log('error fetching users: ',e)
      }finally{
        setIsLoading(false)
      }
    }
      fetchEmployeeUsers()
    },[dispatch, isExecutiveAdmin])

  return (
    <Container fixed maxWidth={'lg'} sx={{ mb: '12px', mt: '12px' }}>
     <MainHeader title='User Management' count={isExecutiveAdmin? executiveEmployees.length :filteredEmployees.length}/>
      <Box mt={5}>
        <Grid container spacing={2} mt={5}>
        {isExecutiveAdmin && <Grid item xs={12} sm={3}>
            <Box
              color={'darkPurple'}
              sx={{
                width: '100%',
                borderRadius: '10px',
                boxShadow: 'unset',
                border: '2px solid #C67EFF',
                background: 'transparent',
              }}>
              <TextField
                disabled={isLoading} 
                sx={{
                  width: "100%", 
                  border: "none", 
                  '& input': { p: 0 },
                  '& .MuiOutlinedInput-root': {
                    p: 5.5,
                    border: '0px', 
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: 'none',
                    },
                  },
                  backgroundColor: '#fff'
                }}
                placeholder='Search User'
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
            </Box>
          </Grid>}
          <Grid item xs={12} sm={2.5}>
            <Button
              disabled={!corporateCode}
              variant={'contained'}
              color={'darkPurple'}
              onClick={handleOpen}
              sx={{
                width: '100%',
                borderRadius: '10px',
                boxShadow: 'unset',
                border: '2px solid #C67EFF',
                background: 'transparent',
                color: '#C67EFF',
                '&.Mui-disabled': {
                  background: 'transparent',
                  color: '#C67EFF',
                },
                ':hover': {
                  background: 'transparent',
                  color: '#C67EFF',
                },
              }}>
              Add Employees
            </Button>
          </Grid>
          <Grid item xs={12} sm={3}>
            <a download={isExecutiveAdmin?"mePrismOnboardingExecutive.csv":"mePrismOnboarding.csv"} 
            href={isExecutiveAdmin? "/mePrismOnboardingExecutive.csv":"/mePrismOnboarding.csv"}>
              <Button
                variant={'contained'}
                color={'darkPurple'}
                size={'large'}
                sx={{
                  width: '100%',
                  borderRadius: '10px',
                  boxShadow: 'unset',
                  background: 'transparent',
                  border: '2px solid #C67EFF',
                  mb: 2, 
                  color: '#C67EFF',
                  '&.Mui-disabled': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                  ':hover': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                }}>
                <Typography
                  sx={{
                    color: '#C67EFF',
                    fontSize: '18px',
                    '@media (max-width: 600px)': {
                      fontSize: '14px',
                    },
                  }}>
                  Download CSV Template
                </Typography>
              </Button>
            </a>
          </Grid>
          
        </Grid>
        <AddEmplyeesModal open={open} isExecutive={isExecutiveAdmin}/>
        {!isLoading?
        <Box sx={{ mt: 5 }}>
          {isExecutiveAdmin? <ExecutiveUserManagementListItem searchValue={searchValue}/> :
          <UserManagementListItem />}
        </Box>:
         <div style={{height:'80vh', width:'100%', display: 'flex', justifyContent: 'center', alignItems:'center'}}>
              <CircularProgress color = 'info'></CircularProgress>
          </div>
        }
      </Box>
    </Container>
  )
}

export default UserManagementView
